import React from "react";
import LogIncidentes from "./LogIncidentes";
import CRUDincidente from "./CRUDincidente";

export default function AltaIncidente({ incidente }) {

  return (
    <div id="incidente" style={Sincidente}>
      <CRUDincidente incidente={incidente} />
      <LogIncidentes incidente={incidente} />
    </div>
  );
}

const Sincidente = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "91vw",
};

